export const finishEnLocale = {
  'finish.payment-successfully': 'Your payment was made successfully',
  'finish.payment-successfully-code': 'Purchase code: {clcCodigo}',
  'finish.payment-successfully-hi': 'Hi, {name}',
  'finish.payment-successfully-review':
    'Your payment has been made successfully. Please take a moment to review the details of your order and make sure they are correct.',
  'finish.payment-successfully-sent':
    'A confirmation email has been sent with the details to',
  'finish.payment-successfully-download': 'Download',
  'finish.payment-successfully-share': 'Share',
  'finish.payment-successfully-ticketsDetail': 'Tickets detail',
  'finish.payment-successfully-quantity': 'Quantity',
  'finish.payment-successfully-price': 'Price',
  'finish.subTotal': 'Subtotal',
  'finish.payment-successfully-fees': 'Fees',
  'finish.payment-successfully-total': 'Total:',
  'finish.view-my-tickets': 'View my tickets',
  'finish.buy-again': 'Buy again',
} as const;

export const finishEsLocale = {
  'finish.payment-successfully': 'Tu pago se realizó con éxito',
  'finish.payment-successfully-code': 'Código de compra: {clcCodigo}',
  'finish.payment-successfully-hi': 'Hola, {name}',
  'finish.payment-successfully-review':
    'Tu pago se ha realizado con éxito. Por favor, tómate un momento para revisar los detalles de tu pedido y asegurarte de que sean correctos.',
  'finish.payment-successfully-sent':
    'Se ha enviado un correo de confirmación con los detalles a',
  'finish.payment-successfully-download': 'Descargar',
  'finish.payment-successfully-share': 'Compartir',
  'finish.payment-successfully-ticketsDetail': 'Detalle de tickets',
  'finish.payment-successfully-quantity': 'Cantidad',
  'finish.payment-successfully-price': 'Precio',
  'finish.subTotal': 'Subtotal',
  'finish.payment-successfully-fees': 'Recargos',
  'finish.payment-successfully-total': 'Total:',
  'finish.view-my-tickets': 'Ver mis tickets',
  'finish.buy-again': 'Comprar de nuevo',
} as const;
